/* ============================================================
   Deal Page — countdown timer
   Reads data-end-date (ISO 8601 with timezone offset) from the
   hero element and ticks every second. On expiry: hides the timer
   blocks, shows the ended message, and repoints the CTA.
   ============================================================ */
(function () {
  'use strict';

  var hero = document.querySelector('[data-dp-hero]');
  if (!hero) return;

  var endDateStr = hero.getAttribute('data-end-date');
  var endTime = Date.parse(endDateStr);
  if (isNaN(endTime)) return;

  var daysEl = hero.querySelector('[data-dp-days]');
  var hoursEl = hero.querySelector('[data-dp-hours]');
  var minsEl = hero.querySelector('[data-dp-minutes]');
  var secsEl = hero.querySelector('[data-dp-seconds]');
  var timerEl = hero.querySelector('[data-dp-countdown]');
  var endedEl = hero.querySelector('[data-dp-ended]');
  var ctaEl = hero.querySelector('[data-dp-cta]');
  var srStatusEl = hero.querySelector('[data-dp-sr-status]');

  var lastMinuteAnnounced = -1;
  var timerId;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function buildSrPhrase(days, hours, mins) {
    var parts = [];
    if (days > 0) parts.push(days + (days === 1 ? ' day' : ' days'));
    if (hours > 0) parts.push(hours + (hours === 1 ? ' hour' : ' hours'));
    parts.push(mins + (mins === 1 ? ' minute' : ' minutes'));
    return parts.join(', ') + ' remaining';
  }

  function tick() {
    var diff = endTime - Date.now();
    if (diff <= 0) {
      if (timerEl) timerEl.hidden = true;
      if (endedEl) endedEl.hidden = false;
      if (ctaEl) {
        ctaEl.textContent = 'Browse Latest Deals';
        ctaEl.setAttribute('href', '/collections/all');
      }
      if (srStatusEl && endedEl) {
        srStatusEl.textContent = endedEl.textContent.trim();
      }
      if (timerId) clearInterval(timerId);
      return;
    }
    var days = Math.floor(diff / (1000 * 60 * 60 * 24));
    var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var secs = Math.floor((diff % (1000 * 60)) / 1000);
    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minsEl) minsEl.textContent = pad(mins);
    if (secsEl) secsEl.textContent = pad(secs);

    var totalMinutes = Math.floor(diff / 60000);
    if (srStatusEl && totalMinutes !== lastMinuteAnnounced) {
      lastMinuteAnnounced = totalMinutes;
      srStatusEl.textContent = buildSrPhrase(days, hours, mins);
    }
  }

  tick();
  timerId = setInterval(tick, 1000);
})();

/* ── Banner slider (Session 2 add-on) ── */
(function () {
  document.querySelectorAll('[data-dp-slider]').forEach(function (root) {
    var track = root.querySelector('[data-dp-slider-track]');
    var slides = track ? track.querySelectorAll('[data-dp-slide]') : [];
    var dots = root.querySelectorAll('[data-dp-slider-dot]');
    var prev = root.querySelector('[data-dp-slider-prev]');
    var next = root.querySelector('[data-dp-slider-next]');
    if (!track || slides.length < 1) return;

    var idx = 0;
    var auto = root.getAttribute('data-autoplay') === '1';
    var period = (parseInt(root.getAttribute('data-autoplay-secs'), 10) || 5) * 1000;
    var timer = null;

    function go(i) {
      idx = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-100 * idx) + '%)';
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === idx);
      });
    }
    function step()  { go(idx + 1); }
    function start() { if (auto && slides.length > 1) timer = setInterval(step, period); }
    function stop()  { if (timer) { clearInterval(timer); timer = null; } }

    if (prev) prev.addEventListener('click', function () { stop(); go(idx - 1); start(); });
    if (next) next.addEventListener('click', function () { stop(); go(idx + 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        stop();
        go(parseInt(d.getAttribute('data-dp-slider-dot'), 10) || 0);
        start();
      });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    start();
  });
})();

/* ---------- Product rail: prev/next arrow scrolling ---------- */
(function () {
  function initRail(rail) {
    var track = rail.querySelector('[data-dp-rail-track]');
    var prev  = rail.querySelector('[data-dp-rail-prev]');
    var next  = rail.querySelector('[data-dp-rail-next]');
    if (!track || !prev || !next) return;

    function step() {
      // Scroll by ~5 cards = container width minus a small overlap.
      return Math.max(track.clientWidth - 40, 200);
    }
    function update() {
      var atStart = track.scrollLeft <= 4;
      var atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      prev.toggleAttribute('disabled', atStart);
      next.toggleAttribute('disabled', atEnd);
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left:  step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    // Wait one frame so layout settles before initial state check.
    requestAnimationFrame(update);
  }
  function boot() {
    document.querySelectorAll('[data-dp-rail]').forEach(initRail);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ── Shop-by-Brand auto-scroll marquee (mobile only) ─────────────────────
   On phones the brand strip (.deal-page-tiles--scroll) loops continuously
   like a marquee. We clone the tiles once for a seamless wrap and advance
   scrollLeft each frame, resetting at the half-way point. Pauses on touch
   and honours prefers-reduced-motion. Desktop renders a static grid, so
   this no-ops there. */
(function () {
  var mqMobile = window.matchMedia('(max-width: 640px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SPEED = 0.45; // px per frame ≈ 27px/s, gentle

  function initMarquee(strip) {
    if (strip.dataset.dpMarquee) return;
    if (!mqMobile.matches || mqReduce.matches) return;
    var originals = Array.prototype.slice.call(strip.children);
    if (originals.length < 3) return; // too few to bother looping
    strip.dataset.dpMarquee = '1';

    // Duplicate the set so the row can wrap without a visible jump.
    originals.forEach(function (t) {
      var c = t.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.tabIndex = -1;
      strip.appendChild(c);
    });

    var half = strip.scrollWidth / 2;
    var paused = false;
    function recalc() { half = strip.scrollWidth / 2; }
    window.addEventListener('load', recalc);
    window.addEventListener('resize', recalc);

    function loop() {
      if (!paused && half > 0) {
        strip.scrollLeft += SPEED;
        if (strip.scrollLeft >= half) strip.scrollLeft -= half;
      }
      requestAnimationFrame(loop);
    }
    strip.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    strip.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 1800); }, { passive: true });
    strip.addEventListener('mouseenter', function () { paused = true; });
    strip.addEventListener('mouseleave', function () { paused = false; });
    requestAnimationFrame(loop);
  }

  function boot() {
    document.querySelectorAll('.deal-page-tiles--scroll').forEach(initMarquee);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
